/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const RiseAndShine = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnsa="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
        x="0px"
        y="0px"
        width="245.8px"
        height="58.8px"
        viewBox="0 0 245.8 58.8"
        xmlSpace="preserve"
        className={className}
    >
        <g>
            <g>
                <path
                    fill={color}
                    d="M109.9,11.5c0,1.8,0,3.5,0,5.2c0,3,0,6.1,0,9.1c0,1-0.4,1.5-1.4,1.4c-1-0.1-2,0-3,0c-0.8,0-1.2-0.3-1.2-1.1
			c0-7.7,0-15.4,0-23c0-0.8,0.3-1.1,1.1-1.1c1.7,0,3.4,0,5,0c0.9,0,1.1,0.6,1.3,1.3c1.1,3.8,2.3,7.7,3.4,11.5c0.1,0.5,0.3,1,0.5,1.6
			c0.4-0.5,0.2-0.9,0.2-1.2c0-3.8,0-7.5,0-11.3c0-1.7,0.1-1.8,1.8-1.8c0.9,0,1.8,0,2.8,0c0.8,0,1.2,0.3,1.2,1.1c0,7.7,0,15.4,0,23
			c0,0.7-0.3,1.1-1.1,1.1c-1.6,0-3.2,0-4.8,0c-0.9,0-1.1-0.5-1.3-1.2c-1.4-4.6-2.7-9.1-4.1-13.7C110.3,12,110.3,11.7,109.9,11.5z"
                />
                <path
                    fill={color}
                    d="M209,11.6c-0.3,0.5-0.2,0.9-0.2,1.4c0,4.2,0,8.5,0,12.7c0,1.1-0.3,1.6-1.4,1.5c-1-0.1-1.9,0-2.9,0c-0.9,0-1.3-0.3-1.3-1.3
			c0-3,0-5.9,0-8.9c0-4.6,0-9.1,0-13.7c0-1.1,0.4-1.5,1.5-1.5c1.4,0.1,2.9,0.1,4.3,0c1,0,1.4,0.3,1.7,1.3c1.3,4.4,2.6,8.7,3.9,13.1
			c0.1,0.2,0.1,0.4,0.3,0.5c0-0.4,0-0.7,0-1.1c0-4.1,0-8.2,0-12.3c0-1.1,0.4-1.5,1.5-1.4c1,0.1,2,0,3,0c0.8,0,1.2,0.2,1.2,1.1
			c0,7.7,0,15.3,0,23c0,0.8-0.4,1.1-1.2,1.1c-1.5,0-3,0-4.4,0c-1,0-1.4-0.4-1.7-1.3c-1.3-4.5-2.6-8.9-3.9-13.3
			C209.3,12.2,209.2,12,209,11.6z"
                />
                <path
                    fill={color}
                    d="M14.3,49.7c0.6-4,1.2-8,1.7-12.1c0.3-2,0.3-2.1,2.4-2.1c3.3,0,2.7-0.5,3.4,3c0.6,3.5,1.1,7,1.6,10.4
			c0,0.3,0.1,0.6,0.3,0.9c0.5-4.3,1-8.6,1.5-13c0.1-1,0.5-1.4,1.5-1.4c0.8,0,1.6,0,2.4,0c1.1-0.1,1.4,0.3,1.2,1.4
			c-0.8,4.4-1.5,8.7-2.3,13.1c-0.4,2.1-0.8,4.2-1.1,6.4c-0.1,0.8-0.5,1.2-1.3,1.2c-1.1,0-2.2-0.1-3.2,0c-1.1,0.1-1.5-0.4-1.7-1.4
			c-0.5-3.6-1-7.2-1.5-10.8c-0.1-0.7-0.2-1.4-0.5-2.1c-0.4,2.9-0.8,5.9-1.2,8.8c-0.2,1.5-0.5,3-0.7,4.5c-0.1,0.8-0.5,1-1.2,1
			c-1.2,0-2.4,0-3.6,0c-0.8,0-1.2-0.4-1.3-1.2C9.9,51.5,9,46.6,8.1,41.7c-0.3-1.6-0.6-3.1-0.9-4.7c-0.2-1,0.1-1.5,1.1-1.4
			c0.9,0,1.8,0,2.8,0c0.9,0,1.3,0.3,1.4,1.2c0.4,3.8,0.9,7.6,1.4,11.4c0.1,0.5,0.2,1,0.2,1.5C14.2,49.7,14.3,49.7,14.3,49.7z"
                />
                <path
                    fill={color}
                    d="M22.3,14.6c3,1.1,3.2,3.5,3.2,5.9c0,1.5,0,3,0.2,4.4c0,0.3,0.1,0.6,0.2,0.9c0.6,1.3,0.6,1.3-0.8,1.3c-1.2,0-2.5,0-3.7,0
			c-1.6,0-1.8-0.2-2-1.9c-0.1-1.8-0.2-3.7-0.3-5.5c-0.1-2.4-0.8-3-3.2-3c-0.8,0-1.1,0.4-1.1,1.2c0,2.6,0,5.1,0,7.7
			c0,1.2-0.4,1.6-1.5,1.5c-1-0.1-2.1,0-3.1,0c-1.5,0-1.6-0.1-1.6-1.7c0-6.5,0-13,0-19.6c0-1,0-1.9,0-2.9c0-0.8,0.4-1.2,1.2-1.1
			c3.4,0,6.9-0.1,10.3,0c3.6,0.1,5.9,3.5,5.5,7.6C25.4,11.7,24.5,13.4,22.3,14.6z M14.9,9.3C14.9,9.3,14.9,9.3,14.9,9.3
			c0,0.6,0,1.3,0,1.9c0,0.9,0.3,1.2,1.2,1.2c1.2,0,2.3-0.3,2.9-1.4c0.7-1.2,0.6-2.6-0.1-3.8c-0.4-0.7-2.4-1.3-3.4-1
			c-1.1,0.3-0.5,1.3-0.6,2C14.9,8.6,14.9,9,14.9,9.3z"
                />
                <path
                    fill={color}
                    d="M173.3,14.5c0-3.7,0-7.4,0-11c0-1.5,0.1-1.6,1.6-1.6c1.1,0,2.2,0,3.4,0c0.9,0,1.3,0.4,1.3,1.3c0,2.3,0,4.6,0,6.8
			c0,0.9,0.3,1.3,1.3,1.2c3.6-0.1,3,0.4,3-2.9c0-1.7,0-3.4,0-5c0-1.1,0.4-1.4,1.4-1.4c1.1,0,2.2,0.1,3.4,0c1.2-0.1,1.5,0.5,1.5,1.6
			c0,5.2,0,10.5,0,15.7c0,2.2,0,4.5,0,6.7c0,0.9-0.3,1.3-1.3,1.3c-1.2,0-2.5,0-3.7,0c-0.9,0-1.3-0.4-1.3-1.3c0-2.6,0-5.2,0-7.8
			c0-1.2-0.4-1.5-1.5-1.5c-3.2,0.1-2.8-0.3-2.8,2.7c0,2.2,0,4.3,0,6.5c0,1-0.3,1.5-1.4,1.4c-1.2-0.1-2.4-0.1-3.6,0
			c-1,0-1.3-0.4-1.3-1.3C173.3,22,173.3,18.3,173.3,14.5z"
                />
                <path
                    fill={color}
                    d="M125.2,14.5c0-3.7,0-7.4,0-11.2c0-1.2,0.4-1.5,1.5-1.5c2.8,0.1,5.6,0,8.4,0c3.3,0,5.9,2.1,6.7,5.3
			c1.1,4.6,1.1,9.3,0.1,13.9c-0.8,3.9-2.9,5.7-6.9,6c-2.9,0.3-5.7,0.2-8.6,0.2c-0.9,0-1.3-0.4-1.3-1.3
			C125.2,22.2,125.2,18.4,125.2,14.5z M131.3,14.5c0,2.3,0,4.6,0,6.8c0,0.5-0.1,1,0.6,1.2c1.7,0.5,3.5-0.4,3.9-2.1
			c0.9-3.7,0.8-7.5,0.2-11.3c-0.3-2-1.2-2.5-3.2-2.6c-1.1,0-1.5,0.4-1.4,1.5C131.4,10.1,131.3,12.3,131.3,14.5z"
                />
                <path
                    fill={color}
                    d="M99.4,27.1c-3.6,0-3,0.5-3.7-3.1c-0.3-1.7-0.3-1.7-2-1.7c-1,0-1.9,0-2.9,0c-0.8,0-1.1,0.3-1.3,1.1
			c-0.7,3.7-0.7,3.7-4.5,3.7c-2.7,0-2.6,0-2-2.6c1.8-6.9,3.5-13.8,5.2-20.7c0.5-2.1,0.5-2.1,2.7-2.1c1.4,0,2.7,0,4.1,0
			c1,0,1.5,0.4,1.7,1.3c1,4,2,8,3,12c0.9,3.5,1.8,7.1,2.7,10.6c0.4,1.5,0.3,1.6-1.2,1.6C100.6,27.1,100,27.1,99.4,27.1z M92.4,8.1
			c-0.4,2.2-0.8,4.5-1.3,6.7c-0.5,2.8-0.5,2.9,2.4,2.7c0.7,0,1-0.2,0.8-0.9C93.7,13.8,93.4,10.9,92.4,8.1z"
                />
                <path
                    fill={color}
                    d="M45.9,27.6c-1.6,0.2-3.2-0.2-4.8-0.9c-2.5-1.1-3.9-4.2-3.2-6.8c0.1-0.6,0.5-0.7,1-0.7c1.3,0,2.6,0,3.8,0
			c0.8,0,1.2,0.3,1.2,1.1c0,0.2,0,0.4,0,0.6c0.1,1.5,0.9,2.4,2.2,2.5c1.3,0.1,2.4-0.9,2.6-2.3c0.2-1.4-0.4-2.5-1.7-3.3
			c-1.4-0.8-2.9-1.1-4.3-1.8c-4.7-2.2-6.2-7.4-3.4-11.8c0.4-0.6,0.9-1.1,1.5-1.5c3.7-2,7.4-2.1,11.1,0c2.1,1.2,2.6,3.2,2.6,5.5
			c0,0.6-0.3,0.9-0.9,0.9c-1.4,0-2.8,0-4.2,0c-1,0-0.9-0.8-1-1.5c-0.3-1.4-1-2.1-2.2-2c-1.3,0.1-2.1,1-2,2.5c0,0.8,0.3,1.5,0.8,2
			c0.6,0.6,1.4,1,2.1,1.3c1.1,0.5,2.1,0.9,3.2,1.3c3.6,1.5,5.2,4.5,4.5,8.6c-0.6,3.8-3.2,6.1-7.1,6.3C47.2,27.6,46.6,27.6,45.9,27.6
			z"
                />
                <path
                    fill={color}
                    d="M167.4,9.1c-0.4,0-0.8,0-1.2,0c-1.2,0.2-1.8-0.2-2-1.5c-0.2-1.6-1.1-2.2-2.5-1.9c-1.2,0.3-2,1.7-1.6,3
			c0.2,0.8,0.7,1.5,1.4,2c1.5,1,3.2,1.3,4.7,2.1c4.6,2.1,6.1,7.6,3.3,11.8c-1.2,1.8-3,2.6-4.9,2.9c-2.4,0.4-4.8,0.3-7.1-0.5
			c-3-1.1-4.2-4-3.8-6.9c0.1-0.5,0.4-0.8,0.9-0.8c1.4,0,2.7,0,4.1,0c1,0,1,0.7,1,1.4c0,1,0.2,2,1.3,2.5c1.1,0.5,2.4,0.3,3.1-0.6
			c0.7-0.9,0.7-2.8,0-3.7c-0.9-1.1-2.2-1.5-3.5-2c-0.7-0.3-1.4-0.5-2.1-0.9c-3.7-1.8-5.1-4.5-4.5-8.6c0.5-3.1,2.4-5.1,5.5-5.7
			c2.1-0.4,4.3-0.5,6.4,0.2c2.8,0.9,4.5,3.1,4.6,5.9c0,0.9-0.2,1.4-1.2,1.3C168.6,9.1,168,9.1,167.4,9.1
			C167.4,9.1,167.4,9.1,167.4,9.1z"
                />
                <path
                    fill={color}
                    d="M57.4,14.4c0-3.7,0-7.4,0-11c0-1.1,0.4-1.5,1.6-1.5c4,0,7.9,0,11.9,0c1.1,0,1.6,0.3,1.5,1.4c-0.1,0.8,0,1.7,0,2.5
			c0,0.8-0.4,1.1-1.2,1.1c-2,0-3.9,0-5.9,0c-1,0-1.5,0.3-1.4,1.4c0.1,4-0.5,3.3,3.3,3.4c1.2,0,2.3,0,3.5,0c0.8,0,1.2,0.3,1.2,1.1
			c0,0.9,0,1.8,0,2.6c0,0.8-0.4,1.1-1.2,1.1c-1.8,0-3.7,0-5.5,0c-0.9,0-1.3,0.3-1.3,1.3c0,0.9,0.1,1.8,0,2.8
			c-0.1,1.1,0.3,1.5,1.4,1.5c2-0.1,4,0,6,0c1.1,0,1.5,0.4,1.5,1.5c-0.1,4.2,0.5,3.6-3.5,3.6c-3.4,0-6.8,0-10.2,0
			c-1.5,0-1.6-0.1-1.6-1.7C57.4,21.8,57.4,18.1,57.4,14.4z"
                />
                <path
                    fill={color}
                    d="M224.1,14.5c0-3.7,0-7.4,0-11.2c0-1.1,0.3-1.5,1.4-1.5c4,0,7.9,0,11.9,0c1,0,1.4,0.3,1.4,1.4c-0.1,4.4,0.6,3.6-3.6,3.7
			c-1.3,0-2.6,0-3.8,0c-0.8,0-1.2,0.3-1.2,1.1c0,0.8,0,1.7,0,2.5c0,0.8,0.3,1.2,1.2,1.1c1.9,0,3.8,0,5.6,0c1,0,1.4,0.3,1.4,1.3
			c-0.1,4.2,0.5,3.5-3.4,3.6c-1.2,0-2.3,0-3.5,0c-0.9,0-1.3,0.4-1.3,1.3c0,1,0,2,0,3c0,0.9,0.3,1.2,1.2,1.2c2.2,0,4.3,0,6.5,0
			c1.1,0,1.5,0.4,1.4,1.5c-0.1,4.3,0.6,3.6-3.6,3.6c-3.4,0-6.8,0-10.2,0c-1,0-1.4-0.3-1.4-1.4C224.1,22,224.1,18.3,224.1,14.5z"
                />
                <path
                    fill={color}
                    d="M60.9,46.7c2.9,0.7,2.8,3,3.1,5.1c0.2,1.8-0.4,3.6,0.6,5.3c0.2,0.4-0.2,0.5-0.6,0.5c-1.3,0-2.6,0-4,0c-0.7,0-1-0.4-1.1-1
			c-0.3-1.3-0.2-2.5-0.2-3.8c0-0.9-0.1-1.8-0.3-2.7c-0.2-0.7-0.6-1.2-1.3-1.4c-1.8-0.4-2.3,0-2.3,1.8c0,2,0,4,0,6
			c0,0.9-0.3,1.2-1.2,1.2c-1,0-1.9,0-2.9,0c-0.9,0-1.3-0.4-1.3-1.3c0-6.5,0-12.9,0-19.4c0-0.7,0.1-1.3,1-1.3c2.9,0,5.8-0.2,8.6,0.1
			c2.9,0.3,4.4,1.7,4.9,4.3C64.6,42.9,63.7,45.1,60.9,46.7z M54.8,41.9c0,0.4,0,0.9,0,1.3c-0.1,1.1,0.4,1.5,1.5,1.4
			c1,0,1.8-0.3,2.2-1.3c0.4-1.1,0.6-2.2-0.2-3.2c-0.7-0.9-1.8-1-2.9-0.7c-1,0.2-0.5,1.2-0.6,1.8C54.7,41.5,54.8,41.7,54.8,41.9z"
                />
                <path
                    fill={color}
                    d="M81.1,46.5c0-3.2,0-6.3,0-9.5c0-1.1,0.3-1.6,1.5-1.5c2.6,0.1,5.1-0.1,7.7,0.2c2.7,0.3,4.4,1.8,5,4.3
			c1.2,4.4,1.1,8.9-0.1,13.3c-0.6,2.3-2.3,3.6-4.6,4c-2.8,0.5-5.7,0.3-8.5,0.3c-0.9,0-1-0.6-1-1.3C81.1,53,81.1,49.8,81.1,46.5z
			 M86.4,46.5c0,1.8,0,3.5,0,5.3c0,1.7,1.1,2.3,2.6,1.5c0.7-0.4,1.1-1.1,1.2-1.8c0.6-3.2,0.7-6.5,0.1-9.7c-0.3-1.6-1-2-2.6-2.1
			c-0.9,0-1.4,0.3-1.4,1.3C86.4,42.7,86.4,44.6,86.4,46.5z"
                />
                <path
                    fill={color}
                    d="M31.7,46.4c0-2.2,0-4.5,0.7-6.6c0.7-2.3,2.2-3.8,4.6-4.4c1.6-0.4,3.2-0.4,4.7,0c2.9,0.7,4.5,2.6,4.9,5.4
			c0.6,3.7,0.6,7.5,0,11.2c-0.8,5-4.5,6.3-9,5.8c-3.3-0.4-5-2.3-5.7-5.8C31.6,50.1,31.7,48.3,31.7,46.4z M41.5,46.5
			c0-1.3,0-2.6,0-3.8c0-1-0.2-1.9-0.5-2.8c-0.3-0.8-0.9-1.1-1.7-1c-0.8,0-1.3,0.4-1.6,1.2c-0.1,0.3-0.2,0.7-0.2,1
			c-0.4,3.7-0.4,7.3,0,11c0.2,1.4,0.8,2.1,1.9,2.1c1.1,0,1.7-0.6,1.9-2C41.6,50.3,41.5,48.4,41.5,46.5z"
                />
                <path
                    fill={color}
                    d="M135.7,57.6c-3.1,0-2.5,0.2-3.1-2.6c-0.3-1.3-0.8-1.8-2.1-1.6c-1,0.1-2.1-0.3-2.9,0.2c-0.9,0.6-0.6,1.8-0.8,2.8
			c-0.2,0.9-0.7,1.4-1.7,1.3c-0.9,0-1.8,0-2.8,0c-1,0-1.4-0.3-1.1-1.3c0.8-3.1,1.6-6.3,2.4-9.4c0.8-3.3,1.7-6.5,2.5-9.8
			c0.3-1.2,0.9-1.7,2.1-1.6c1.1,0.1,2.2,0.1,3.4,0c1.1-0.1,1.7,0.4,1.9,1.5c0.8,3.4,1.7,6.8,2.6,10.2c0.7,2.9,1.4,5.7,2.1,8.6
			c0.4,1.7,0.3,1.7-1.4,1.8C136.4,57.6,136.1,57.6,135.7,57.6z M129.8,40.6c-0.1,0-0.1,0-0.2,0c-0.5,2.5-0.9,5.1-1.4,7.6
			c-0.1,0.7,0.1,1,0.8,1c0.4,0,0.9,0,1.3,0c0.8,0,1-0.4,0.8-1.1C130.8,45.6,130.3,43.1,129.8,40.6z"
                />
                <path
                    fill={color}
                    d="M171.1,50.6c0.2,0,0.5,0,0.7,0c1.7,0,1.7,0,1.9,1.8c0.1,1.1,0.8,1.8,1.8,1.8c1.2,0.1,2-0.6,2.2-1.7
			c0.3-1.7-0.4-2.7-2.2-3.5c-1.2-0.5-2.4-0.9-3.5-1.5c-2.8-1.4-4-4-3.3-7.5c0.5-2.6,2.5-4.3,5.5-4.8c2-0.3,3.8-0.1,5.6,0.7
			c2.1,1,2.8,2.8,3,4.9c0.1,0.7-0.3,1-0.9,1c-1.1,0-2.2,0-3.2,0c-0.8,0-1-0.5-1.1-1.2c0-0.8-0.2-1.6-1.1-1.8
			c-0.7-0.2-1.6-0.2-2.1,0.5c-0.6,0.7-0.7,1.6-0.3,2.5c0.4,0.9,1.1,1.4,1.9,1.7c1,0.4,2.1,0.9,3.1,1.3c3.2,1.3,4.5,3.7,4.1,7.3
			c-0.4,3.3-2.3,5.2-5.8,5.6c-2,0.2-4.1,0.1-6-0.8c-2.4-1.1-2.9-3.4-2.9-5.6c0-0.5,0.3-0.8,0.8-0.8
			C169.9,50.6,170.5,50.6,171.1,50.6C171.1,50.6,171.1,50.6,171.1,50.6z"
                />
                <path
                    fill={color}
                    d="M108.1,50.6c0.3,0,0.6,0,1,0c1.1-0.1,1.6,0.2,1.7,1.4c0,1.1,0.5,2,1.7,2.2c0.9,0.1,1.7,0,2.2-0.9c0.6-1,0.4-2.5-0.3-3.3
			c-0.5-0.5-1.1-0.9-1.8-1.1c-1.2-0.5-2.3-0.9-3.4-1.4c-2.8-1.4-3.9-4.1-3.2-7.7c0.5-2.4,2.7-4.1,5.5-4.5c1.9-0.2,3.7-0.1,5.5,0.7
			c2,0.9,3.2,2.9,3.1,5c0,0.7-0.4,1-1,1c-1.1,0-2.2,0-3.2,0c-0.7,0-1-0.4-1-1.1c0-0.9-0.2-1.7-1.2-1.9c-0.8-0.2-1.6-0.2-2.1,0.7
			c-0.6,0.9-0.6,1.9,0.1,2.8c0.6,0.8,1.4,1.2,2.2,1.5c1.3,0.5,2.7,1,3.9,1.8c2.3,1.4,2.8,3.7,2.6,6.1c-0.2,2.4-1.1,4.4-3.5,5.3
			c-2.7,1.1-5.5,1.1-8.2-0.1c-2.2-1-3.4-3.3-3-5.6c0.1-0.5,0.3-0.8,0.9-0.8C107,50.6,107.6,50.6,108.1,50.6
			C108.1,50.6,108.1,50.6,108.1,50.6z"
                />
                <path
                    fill={color}
                    d="M154,46.4c0-3.1,0-6.2,0-9.3c0-1.1,0.3-1.6,1.5-1.6c3.3,0.1,6.6,0,9.8,0c1.1,0,1.5,0.4,1.5,1.5c0,3.3,0.1,2.8-2.8,2.9
			c-1.2,0-2.4,0-3.6,0c-0.7,0-1,0.3-1,1c0,3.6-0.3,3,2.8,3.1c1,0,2,0,3,0c0.8,0,1.2,0.4,1.2,1.2c0,3.8,0.3,3.3-3.1,3.3
			c-1,0-1.9,0-2.9,0c-1.4,0-1.1,1.2-1,1.8c0.2,0.9-0.9,2.5,1,2.7c1.7,0.2,3.5,0.1,5.3,0c1,0,1.4,0.3,1.4,1.4c-0.1,3.5,0.3,3.1-3,3.1
			c-2.8,0-5.6,0-8.4,0c-1.4,0-1.6-0.1-1.6-1.6C154,52.8,154,49.6,154,46.4z"
                />
                <path
                    fill={color}
                    d="M199.7,14.5c0,3.7,0,7.4,0,11.1c0,1.1-0.3,1.6-1.4,1.5c-1.1-0.1-2.2-0.1-3.4,0c-1.2,0.1-1.5-0.5-1.5-1.6
			c0-6.3,0-12.6,0-18.9c0-1.2,0-2.4,0-3.6c0-0.9,0.4-1.2,1.3-1.2c1.2,0,2.4,0.1,3.6,0c1.1-0.1,1.4,0.5,1.4,1.5
			C199.7,7.1,199.7,10.8,199.7,14.5z"
                />
                <path
                    fill={color}
                    d="M29,14.5c0-3.7,0-7.4,0-11.2c0-1.1,0.3-1.5,1.4-1.5c1.2,0.1,2.3,0,3.5,0c1,0,1.4,0.4,1.4,1.4c0,2.7,0,5.4,0,8
			c0,4.7,0,9.4,0,14.2c0,1.6-0.1,1.7-1.7,1.7c-1,0-2,0-3,0c-1.5,0-1.5-0.1-1.5-1.6C29,21.9,29,18.2,29,14.5z"
                />
                <path
                    fill={color}
                    d="M145.2,44.4c0,2.5,0,5,0,7.4c0,0.9,0.3,1.3,1.3,1.3c1.6,0,3.2,0,4.8,0c0.9,0,1.4,0.3,1.4,1.3c0,3.7,0.3,3.2-3.1,3.2
			c-2.7,0-5.4,0-8,0c-1.5,0-1.6-0.1-1.6-1.5c0-6.3,0-12.6,0-19c0-1.1,0.3-1.6,1.5-1.6c0.8,0.1,1.5,0.1,2.3,0
			c1.1-0.1,1.6,0.4,1.6,1.5C145.2,39.5,145.2,41.9,145.2,44.4z"
                />
                <path
                    fill={color}
                    d="M66.9,46.6c0-3.2,0-6.5,0-9.7c0-1,0.3-1.4,1.3-1.3c0.9,0,1.8,0,2.6,0c1.1-0.1,1.4,0.4,1.4,1.4c0,4.8,0,9.6,0,14.4
			c0,1.7,0,1.7,1.8,1.7c1.4,0,2.9,0,4.3,0c1,0,1.3,0.4,1.4,1.4c0.1,3.2,0.1,3.2-3,3.2c-2.6,0-5.1,0-7.7,0c-2.1,0-2.1,0-2.1-2.1
			C66.9,52.5,66.9,49.5,66.9,46.6z"
                />
            </g>
        </g>
    </svg>
);

RiseAndShine.propTypes = propTypes;
RiseAndShine.defaultProps = defaultProps;

export default RiseAndShine;
